<template>
  <div class="content-activities">
    <div class="header">
      <div class="header-title">Minhas Atividades</div>
      <div class="header-date">{{ displayToday }}</div>
    </div>
    <div
      class="activities-content"
      :class="{ 'empty-activities': shouldShowError }"
    >
      <Error
        v-if="shouldShowError"
        :textTitle="'Tão <span>vazio</span> por aqui...'"
        :textDescription="
          'Não encontramos nenhuma atividade vinculada ao seu usuário no iNews.'
        "
        :imageTitle="'hungry'"
        class="no-activities inside"
      />

      <ProgrammedActivityCard
        v-else
        v-for="(activity, index) in programmedActivities"
        v-bind:key="index"
        :activity="activity"
        :activityType="normalizeType(activity.item_type)"
      />
    </div>
    <LoadingOverlay :enabled="isLoadingActivities" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProgrammedActivityCard from '@/components/mirrorPreview/ProgrammedActivityCard.vue';
import Error from '@/components/shared/Error.vue';
import { normalizeType } from '@/utils/mirrorFormatter.js';
import { weekdayWithDate } from '@/utils/date.js';
import LoadingOverlay from '../shared/LoadingOverlay.vue';
export default {
  name: 'ProgrammedActivityList',
  components: {
    ProgrammedActivityCard,
    Error,
    LoadingOverlay,
  },
  created() {
    this.loadActivities();
  },
  computed: {
    ...mapState({
      isLoadingActivities: state => state.mirror.isLoadingActivities,
      programmedActivities: state => state.mirror.programmedActivities,
    }),
    displayToday() {
      return weekdayWithDate();
    },
    shouldShowError() {
      return !this.programmedActivities.length && !this.isLoadingActivities;
    },
  },
  methods: {
    weekdayWithDate,
    normalizeType,
    loadActivities() {
      this.$store.dispatch('mirror/getProgrammedActivities');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';

.content-activities {
  background-color: $color-background;
  padding: 20px 0 16px 0;
  min-height: 100%;

  .activities-content {
    padding: 0 16px;
  }
  .header {
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    .header-title {
      display: flex;
      flex-wrap: wrap;
      margin: 0 0 40px 0;
      flex: 2;
      font-family: 'globotipo' !important;
      font-weight: 500 !important;
      font-size: 1.2em !important;
      font-style: italic;
      line-height: 1em;
      color: $color-black-64;
    }

    .header-date {
      flex: 1;
      margin: -40px 0 0 0;
      text-align: right;
      font-size: 0.64em;
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
      color: $color-primary;
      text-transform: uppercase;
    }
  }
}
</style>
